<template>
  <moe-page>
    <moe-top :hidePopup="true"></moe-top>
    <div class="coupon_box flex Flexjustify">
      <div class="coupon_content">
        <div class="flex Flexalign FlexBetween content_top">
          <div>修改密码</div>
          <div class="flex Flexalign cursor_pointer" @click="back">
            <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
            <div class="mar_left_10">返回</div>
          </div>
        </div>
        <div class="content">
          <!-- <div class="password_info flex mar_top_20">
            <div class="password_label">原密码：</div>
            <el-input v-model="oldPassword" size="large" style="width: 260px; height: 36px" placeholder=""
              :type="isShowOldPassword ? 'text' : 'password'">
              <template #append>
                <div class="code_get flex Flexalign">
                  <el-image class="eyes_icon cursor_pointer" :src="imgPath('eyes_open.png')"
                    style="width: 24px; height: 24px" v-if="isShowOldPassword"
                    @click="hidePassword(false, 'oldPassword')"></el-image>
                  <el-image class="eyes_icon cursor_pointer" :src="imgPath('eyes_closed.png')"
                    style="width: 24px; height: 24px" v-if="!isShowOldPassword"
                    @click="hidePassword(true, 'oldPassword')"></el-image>
                </div>
              </template>
</el-input>
</div> -->
          <div class="password_info flex mar_top_20">
            <div class="password_label">手机号：</div>
            <div>
              <div class="password_value" v-if="userInfo?.phone">
                {{ $Tools.phoneHide(phone) }}
              </div>
              <div v-else>
                <el-input
                  v-model="phone"
                  @input="(e) => checkPhoneNumber(e)"
                  style="max-width: 600px; height: 38px; border-radius: 10px"
                  placeholder="请输入手机号"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="password_info flex mar_top_20">
            <div class="password_label">验证码：</div>
            <div class="flex FlexBetween code_box">
              <el-input
                v-model="verificationCode"
                @input="(e) => checkNumber(e)"
                style="max-width: 600px; border-radius: 10px"
                placeholder="请输入验证码"
              ></el-input>
              <div class="btn_getCode cursor_pointer mar_left_20" @click="getPhoneCode">
                {{ textCode }}
              </div>
            </div>
          </div>
          <div class="password_info flex mar_top_10">
            <div class="password_label">新密码：</div>
            <div class="password_value">
              <el-input
                v-model="newPassword"
                @change="checkPassword"
                size="large"
                style="width: 260px; height: 36px"
                placeholder=""
                :type="isShowNewPassword ? 'text' : 'password'"
              >
                <template #append>
                  <div class="code_get flex Flexalign">
                    <el-image
                      class="eyes_icon cursor_pointer"
                      :src="imgPath('eyes_open.png')"
                      style="width: 24px; height: 24px"
                      v-if="isShowNewPassword"
                      @click="hidePassword(false, 'newPassword')"
                    ></el-image>
                    <el-image
                      class="eyes_icon cursor_pointer"
                      :src="imgPath('eyes_closed.png')"
                      style="width: 24px; height: 24px"
                      v-if="!isShowNewPassword"
                      @click="hidePassword(true, 'newPassword')"
                    ></el-image>
                  </div>
                </template>
              </el-input>
              <div
                class="warning_text"
                style="padding-left: 0"
                v-if="checkPassword(newPassword, 'new')"
              >
                {{ errorText }}
              </div>
              <div class="flex Flexalign mar_top_10 FlexBetween strength_box">
                <div class="strength_one" :class="[strongLevel == 1 ? 'active_bg' : '']">
                  弱
                </div>
                <div class="strength_one" :class="[strongLevel == 2 ? 'active_bg' : '']">
                  中
                </div>
                <div class="strength_one" :class="[strongLevel == 3 ? 'active_bg' : '']">
                  强
                </div>
              </div>
              <div class="mar_top_10 password_attention">
                建议您使用安全性强的密码，包含数字、大小写字母和符号，且尽量没有规律。
              </div>
            </div>
          </div>
          <div class="password_info flex mar_top_10">
            <div class="password_label">确认新密码：</div>
            <el-input
              v-model="confirmPassword"
              size="large"
              style="width: 260px; height: 36px"
              placeholder=""
              :type="isShowConfirmPassword ? 'text' : 'password'"
            >
              <template #append>
                <div class="code_get flex Flexalign">
                  <el-image
                    class="eyes_icon cursor_pointer"
                    :src="imgPath('eyes_open.png')"
                    style="width: 24px; height: 24px"
                    v-if="isShowConfirmPassword"
                    @click="hidePassword(false, 'confirmPassword')"
                  ></el-image>
                  <el-image
                    class="eyes_icon cursor_pointer"
                    :src="imgPath('eyes_closed.png')"
                    style="width: 24px; height: 24px"
                    v-if="!isShowConfirmPassword"
                    @click="hidePassword(true, 'confirmPassword')"
                  ></el-image>
                </div>
              </template>
            </el-input>
          </div>
          <div class="warning_text" v-if="checkPassword(confirmPassword, '')">
            {{ errorText }}
          </div>
          <div class="btn_save mar_top_50 cursor_pointer" @click="verifyPhone">
            保存修改
          </div>
        </div>
      </div>
    </div>
  </moe-page>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GjkcH5PasswordUpdate",
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },

  components: {},
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      errorText: "",
      strongLevel: "",
      isShowOldPassword: false,
      isShowNewPassword: false,
      isShowConfirmPassword: false,
      textCode: "获取验证码",
      disabled: false,
      verificationCode: "",
      phone: "",
    };
  },

  mounted() {
    if (this.userInfo?.phone) {
      this.phone = this.userInfo.phone;
    }
  },

  methods: {
    checkPhoneNumber(value) {
      this.phone = value.replace(/[^0-9]/g, ""); // 移除非数字字符
    },
    checkNumber(value) {
      this.verificationCode = value.replace(/[^0-9]/g, ""); // 移除非数字字符
    },
    // 获取验证码
    getPhoneCode() {
      if (this.$Tools.empty(this.phone)) {
        this.$Dialog.toast("手机号不能为空", { type: "error" });
        return;
      }
      if (!/^1[345678]\d{9}$/.test(this.phone)) {
        this.$Dialog.toast("请输入正确的手机号", { type: "error" });
        return;
      }
      if (this.disabled) return;
      this.disabled = true;
      let n = 60;
      this.textCode = "重新发送 " + n + "s";
      this.$Api.login.getCode({ phone: this.phone }).then((res) => {
        if (res.data.code == 200) {
          this.$Dialog.toast("验证码已发送");
          const run = setInterval(() => {
            n = n - 1;
            if (n < 0) {
              clearInterval(run);
            }
            this.textCode = "重新发送 " + n + "s";
            if (this.textCode < "重新发送 " + 0 + "s") {
              this.disabled = false;
              this.textCode = "重新获取";
            }
          }, 1000);
        }
      });
    },
    hidePassword(flag, type) {
      if (type == "oldPassword") {
        this.isShowOldPassword = flag;
      } else if (type == "newPassword") {
        this.isShowNewPassword = flag;
      } else if (type == "confirmPassword") {
        this.isShowConfirmPassword = flag;
      }
    },
    checkPassword(value, type) {
      if (!value) return;
      // 允许更多符号（如-?[]等）
      const validCharsRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-?[\]{}]+$/;
      if (!validCharsRegex.test(value)) {
        this.errorText = "仅允许字母、数字和特殊符号!@#$%^&*()_+";
      }
      if (type == "new") {
        this.checkPasswordStrong(this.newPassword);
      }
      return !validCharsRegex.test(value);
    },
    checkPasswordStrong(value) {
      // let reg1 = /^(\d{6,10})|([a-z]{6,10})|([A-Z]{6,10})$/; // 弱
      let reg2 = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/; // 中
      let reg3 = /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,10}/; // 强
      if (reg3.test(value)) {
        this.strongLevel = 3;
      } else {
        if (reg2.test(value)) {
          this.strongLevel = 2;
        } else {
          this.strongLevel = 1;
        }
      }
    },
    verifyPhone() {
      if (this.userInfo?.phone) {
        if (!this.verificationCode) {
          this.$Dialog.toast("请输入验证码", { type: "error" });
          return;
        }
        this.$Api.user
          .checkPhone({ phone: this.phone, verificationCode: this.verificationCode })
          .then(() => {
            this.confirm();
          })
          .catch(() => {});
      } else {
        console.log({
            phone: this.phone,
            verificationCode: this.verificationCode,
            password: this.newPassword,
            newPassword: this.confirmPassword,
          })
        this.$Api.user
          .forgotPassword({
            phone: this.phone,
            verificationCode: this.verificationCode,
            password: this.newPassword,
            newPassword: this.confirmPassword,
          })
          .then(() => {
            this.$Dialog.toast("密码修改成功");
            setTimeout(() => {
              this.back();
            }, 1000);
          }).catch(()=>{});
      }
    },
    confirm() {
      if (!this.newPassword || !this.confirmPassword) {
        this.$Dialog.toast("密码输入不能为空", { type: "error" });
        return;
      }
      if (this.newPassword != this.confirmPassword) {
        this.$Dialog.toast("两次密码输入的不一致", { type: "error" });
        return;
      }
      let flag1 = this.checkPassword(this.confirmPassword);
      let flag2 = this.checkPassword(this.newPassword);
      if (flag1 || flag2) {
        this.$Dialog.toast("密码输入不规范", { type: "error" });
        return;
      }
      // 直接判断两次密码一不一样
      this.$Api.user
        .passwordUpdate({ password: this.newPassword, newPassword: this.confirmPassword })
        .then(() => {
          this.$Dialog.toast("密码修改成功");
          setTimeout(() => {
            this.back();
          }, 1000);
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.coupon_box {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight);
  background: #f3f3f3;

  .coupon_content {
    margin-top: 20px;
    box-sizing: border-box;
    width: $pageMainWidth;
    height: 600px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .content_top {
      font-size: 18px;
      color: #13d6aa;
      border-bottom: 1px solid rgba(20, 20, 20, 0.1);
      padding-bottom: 15px;

      .back_icon {
        width: 24px;
        height: 24px;
      }
    }

    .content {
      .password_info {
        .password_label {
          line-height: 36px;
          width: 120px;
          font-size: 18px;
          color: #333333;
        }

        .code_box {
          // width: 100%;
          // height: 46px;

          .code_input {
            // width: 307px;
          }

          .btn_getCode {
            min-width: 127px;
            height: 36px;
            background: #edeced;
            border-radius: 5px;
            border: 1px solid #d8d8d8;
            color: #2d2d2d;
            text-align: center;
            line-height: 36px;
            font-size: 16px;
            padding: 0 15px;
          }
        }

        .password_value {
          line-height: 36px;

          .strength_box {
            width: 220px;

            .strength_one {
              width: 67px;
              height: 34px;
              background: #ebebeb;
              line-height: 34px;
              text-align: center;
              color: #333333;
              font-weight: 600;
            }

            .active_bg {
              background: linear-gradient(90deg, #00d5c2, #00d498);
              color: #ffffff;
            }
          }

          .password_attention {
            font-size: 14px;
            color: #ff6619;
          }
        }
      }

      .warning_text {
        padding-left: 120px;
        font-size: 14px;
        color: red;
      }

      .btn_save {
        width: 124px;
        height: 36px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-radius: 18px;
        text-align: center;
        line-height: 36px;
        color: #ffffff;
      }
    }
  }
}
</style>
